/**
 * Builds a CSV string from header/row pairs.
 *
 * Used by SPEC-0006 (Draft, not approved for production use) to turn a
 * confirmed document extraction into a file the existing multi-file sold
 * upload flow (SPEC-0001 §1) already knows how to merge and validate —
 * extraction enters that flow exactly like a parsed CSV file, per SPEC-0006's
 * recommendation, rather than needing its own server-side merge path.
 */
function escapeCsvField(value: string): string {
	if (/[",\n\r]/.test(value)) {
		return `"${value.replace(/"/g, '""')}"`;
	}
	return value;
}

export function rowsToCsv(headers: readonly string[], rows: readonly (readonly string[])[]): string {
	const lines = [headers, ...rows].map((line) => line.map(escapeCsvField).join(','));
	return lines.join('\r\n');
}
